import React from 'react';
import { BrainCircuitIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Mechanism() {
  return <section className="py-24 px-6 bg-[#18181b] relative overflow-hidden" data-id="element-216">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-500/5 via-transparent to-transparent opacity-50" data-id="element-217" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-218">
        <FadeIn className="flex justify-center mb-8" data-id="element-219">
          <div className="bg-amber-500/10 p-4 rounded-2xl border border-amber-500/20" data-id="element-220">
            <BrainCircuitIcon className="w-12 h-12 text-amber-500" data-id="element-221" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-222">
          <h2 className="font-bebas text-4xl sm:text-5xl uppercase tracking-wide text-center mb-8" data-id="element-223">
            El Método de Reconfiguración de{' '}
            <span className="text-amber-500" data-id="element-224">Receptores D2</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-225">
          <div className="prose prose-invert prose-lg max-w-none text-zinc-300" data-id="element-226">
            <p className="mb-6" data-id="element-227">
              En lugar de prohibir, vamos a <strong data-id="element-228">reiniciar</strong>. Este
              protocolo utiliza la neuroplasticidad para bajar tus niveles de
              sobreestimulación de forma controlada.
            </p>
            <p data-id="element-229">
              Al reducir la carga química durante 21 días, obligas a tu cerebro
              a "encender" nuevamente sus receptores de placer natural,
              devolviéndote la energía vital y la claridad que dabas por
              perdidas.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}